import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from 'src/app/services/data.service';
import { Order } from 'src/app/models/order';
import { User } from 'src/app/models/User';
import { Mission } from 'src/app/models/mission';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { OptionColumns } from 'src/app/components/forms/autocomplete-field/autocomplete-field.component';
import * as moment from 'moment';

@Component({
  selector: 'app-order-dialog',
  templateUrl: './order-dialog.component.html',
  styleUrls: ['./order-dialog.component.scss']
})
export class OrderDialog implements OnInit {
  public ready = false;
  public btn_save_disabled = false;
  public btn_save_loader = false;
  public form: FormGroup;
  public type: any; // Assurez-vous de la structure correcte pour le type
  public user_level: { value: string, viewValue: string }[] = [];
  public order: Order = null;
  public isAdmin: boolean = false;
  public startDate: any;
  public endDate: any;
  public onUpdate = false;
  public user_identity: string = null;
  //public model_mission_title: string = null;
  public nbApiRequests = 0;//gestion ready
  public nbApiAnswers = 0;
  public promises = []; //liste des promesses

  public editorOptions = {
    toolbar: [
      ['bold', 'italic', 'underline'],
      [{ 'header': 1 }, { 'header': 2 }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'color': [] }],
    ]
  };
  
  //select user id
  public usersOptionsColumns: OptionColumns = {
    id: 'id',
    label: 'firstname',
    operator: 'contain'
  };
  
  //select user id
  public missionsOptionsColumns: OptionColumns = {
    id: 'id',
    label: 'title',
    operator: 'contain'
  }; 

  constructor(
    public dialogRef: MatDialogRef<OrderDialog>,
    public translate: TranslateService,
    public auth: AuthenticationService,
    public dataService: DataService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {

    // Créer le formulaire
    this.form = new FormGroup({     
      user_id: new FormControl((this.data && this.data.item)?this.data.item.user_id:null),
	  model_mission_id: new FormControl((this.data && this.data.item)?this.data.item.model_mission_id:null),
	  max_number_of_mission: new FormControl(null),
	  max_number_of_task: new FormControl(null),	  
      status: new FormControl('new'),
	  comment: new FormControl(null),
    });
  }

  ngOnInit(): void {
    // Charger les données nécessaires pour initialiser le formulaire
    this.promises = [];
	
	if (this.auth.getCurrentAuthUser().hasRole(['super-admin'])) {
      this.form.controls['user_id'].setValidators([Validators.required]);
    }

    if (this.data && this.data.item) {
		this.order = this.data.item;
		this.form.patchValue(this.order);

		if (this.order) {
			if (this.order.user_id > 0) this.loadUser(this.order.user_id);
			if (this.order.model_mission_id > 0) this.loadMissionModel(this.order.model_mission_id);
		}

		// Désactiver le champ user_level si nécessaire
		if (this.order.status !== 'new' && !this.auth.getCurrentAuthUser().hasRole(['super-admin'])) {
			//this.form.get('user_level').disable();
		}
    }

    // Toutes les promesses sont terminées
    Promise.all(this.promises).then(() => {
      this.ready = true;
    }).catch(err => {
      console.log(err);
	  this.ready = true;
    })
  }

  save() {
    this.form.markAllAsTouched();
    if (this.form.valid) {
      // Logique pour sauvegarder les données du formulaire
      if (this.order) {
        this.update(this.order);
      } else {
        this.create();
      }
    } else {
      console.log('Form is invalid');
    }
  }

  create() {
    this.btn_save_disabled = true;
    this.btn_save_loader = true;

    let data = this.form.value;

    this.dataService.postAsPromise('admin/orders', data).then(res => {
      if (res && res.data) {
        this.dialogRef.close({ order: res.data, mode: 'new' });
      } else {
        this.dialogRef.close('bt_save');
      }
      this.btn_save_disabled = false;
      this.btn_save_loader = false;
    }).catch(err => {
      this.btn_save_disabled = false;
      this.btn_save_loader = false;
      console.error('Error while creating order:', err);
    });
  }

  update(item) {
    this.btn_save_disabled = true;
    this.btn_save_loader = true;

    let data = this.form.getRawValue();
    this.dataService.putAsPromise(`admin/orders/${item.id}`, data).then(res => {
      if (res && res.data) {
        this.order = data;
        this.dialogRef.close({ mode: 'update' });
      } else {
        this.dialogRef.close('bt_save');
      }
      this.btn_save_disabled = false;
      this.btn_save_loader = false;
    }).catch(err => {
      this.btn_save_disabled = false;
      this.btn_save_loader = false;
      console.error('Error while updating order:', err);
    });
  }
 

  hasError(controlName: string, errorName: string) {
    if (!controlName) {
      return this.form.hasError(errorName);
    }
    return this.form.controls[controlName].hasError(errorName);
  }
  
	//load user based on order user_id
	loadUser(id){
		if (id > 0){
			this.user_identity = '';
			this.promises.push(this.dataService
				.getAsPromise(`admin/users/${id}`)
				.then((result) => {
					if (result.data) {
						var user = new User(result.data);
						if (user) {
							this.user_identity = user.getIdentity();
							this.form.controls['user_id'].patchValue({
								id: this.order.user_id,
								label: this.user_identity
							});							
							if (this.order)	{
								this.order.user = user;
							}
						}
					}
				})
			)
		}
	}
	
	//load mission model based on model_mission_id
	loadMissionModel(id){
		if (id > 0){
			//this.model_mission_title = '';
			this.promises.push(this.dataService
				.getAsPromise(`admin/missions/${id}`)
				.then((result) => {
					if (result.data) {
						var mission_model = new Mission(result.data);
						if (mission_model) {
							//this.model_mission_title = mission_model.title;
							this.form.controls['model_mission_id'].patchValue({
								id: mission_model.id,
								label: mission_model.title
							});	
							if (this.order)	this.order.mission_model = mission_model;
						}
					}
				})
				.catch(err => {
					//this.model_mission_title = "unknown";
				})				
			)
		} else {
			console.log("id non valide id="+id);
		}
	}	

}
